"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/CreateNew/Compose/Composer.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactdropzone = require('react-dropzone'); var _reactdropzone2 = _interopRequireDefault(_reactdropzone);



var _message = require('shared/validation/chat/message');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _AttachmentTray = require('web/components/Conversation/AttachmentTray'); var _AttachmentTray2 = _interopRequireDefault(_AttachmentTray);
var _ExpandingInput = require('web/components/Conversation/ExpandingInput'); var _ExpandingInput2 = _interopRequireDefault(_ExpandingInput);

const DROPZONE_INPUT_PROPS = { 'aria-label': 'Attach files' }















/* The compose's message box: the conversation composer, with the type's
 * placeholder (amber for an insecure text) and the tray of files to send. */
const Composer = ({
  value, onChange, onSend, files, onAddFiles, onRemoveFile, placeholder, isInsecure, mentionCandidates,
}) => {
  const [mentions, setMentions] = _react.useState([])
  const dropzoneRef = _react.useRef(null)
  const handleChange = _react.useCallback.call(void 0, (_err, v) => onChange(v), [onChange])
  const handleSend = _react.useCallback.call(void 0, () => onSend(value, mentions), [onSend, value, mentions])
  const handlePickAttachment = _react.useCallback.call(void 0, () => _optionalChain([dropzoneRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.open, 'call', _3 => _3()]), [])

  return (
    _react2.default.createElement(_reactdropzone2.default, {
      className: "compose-composer--dropzone",
      disableClick: true,
      inputProps: DROPZONE_INPUT_PROPS,
      onDrop: onAddFiles,
      ref: dropzoneRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}

      , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 
        'compose-composer chat--createMessageBox chat--createMessageBox--stacked',
        isInsecure && 'compose-composer---insecure',
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}
        , files.length > 0 && _react2.default.createElement(_AttachmentTray2.default, { files: files, onRemove: onRemoveFile, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}} )
        , _react2.default.createElement(_ExpandingInput2.default, {
          value: value,
          onChange: handleChange,
          onSend: handleSend,
          onPasteFiles: onAddFiles,
          hasAttachments: files.length > 0,
          onAttachmentClick: handlePickAttachment,
          placeholder: placeholder,
          ariaLabel: "Message",
          maxLength: isInsecure ? _message.MAX_SMS_LENGTH : _message.MAX_MESSAGE_LENGTH,
          mentionCandidates: mentionCandidates,
          mentions: mentions,
          onMentionsChange: setMentions, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, Composer)
